var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmphasis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 24,
    viewBox: "0 0 109 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1535 1.04939C38.2283 4.02011 26.8407 5.01033 18.9808 5.56732C5.3032 6.55757 2.88951 7.05269 3.63219 8.97126C4.99377 12.4989 17.6811 12.4371 63.4173 8.6618C75.7952 7.60968 87.2447 6.80513 88.792 6.80513C96.3425 6.74323 96.4044 -1.2405 71.1535 1.04939ZM69.2968 12.9941C65.5216 13.3035 13.6583 18.1928 9.94492 18.5641C-0.452503 19.4924 -1.87598 20.2351 2.27062 22.8964C8.02632 26.5478 59.3945 19.5543 92.2578 18.626C107.544 18.1928 109.154 17.8833 108.287 15.7172C107.111 12.3752 91.0819 11.2612 69.2968 12.9941Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmphasis);
export default __webpack_public_path__ + "static/media/emphasis.30b6223f035efca5a7bc620e85e082f7.svg";
export { ForwardRef as ReactComponent };